export default __webpack_public_path__ + "static/media/transparentLogo.81df01fe.png";